import { html } from 'htm/preact';
import { Component, createRef } from 'preact';
import { AUTOCOMPLETE_FILTERS_SELECTOR } from '../autocomplete-filters/autocomplete-filters.component';
import { MenuItem } from '@mode/shared/ui';

export type AutocompleteFiltersWrapperElement = HTMLElement & AutocompleteFiltersWrapperPreactComponent;

type Props = {
  matchOnItems: MenuItem[];
  contentTypeItems: MenuItem[];
  selectedMatchOnItems: MenuItem[];
  selectedContentTypeItems: MenuItem[];
};

/**
 * Wrapper component that orchestrates the rendering of the {@link AutocompleteFiltersComponent} custom element.
 * @author Franklin <franklin.clark@thoughtspot.com>
 */
export class AutocompleteFiltersWrapperPreactComponent extends Component<Props, Record<string, never>> {
  /**
   * Reference to the {@link AutocompleteFiltersComponent} Angular Element
   * @member {@link RefObject}
   */
  filtersElementRef = createRef();

  /**
   * Incremental key for the filters component.  This is primarily used to force
   * Preact to re-render the child filters component.
   */
  filtersKey = 0;

  /**
   * Indirectly reload {@link AutocompleteFiltersComponent} Angular Element by incrementing the {@link filtersKey}
   * which will subsequently cause Preact to re-render the component which effectively will call {@link NgElement } connected/disconnected
   * lifecycle methods.  More about custom element callbacks here
   * https://developer.mozilla.org/en-US/docs/Web/API/Web_Components/Using_custom_elements#custom_element_lifecycle_callbacks
   */
  public reloadFilters() {
    this.filtersKey += 1;
  }

  public componentDidUpdate() {
    if (this.filtersElementRef.current) {
      // Pass properties here since the values are not strings
      this.filtersElementRef.current.selectedMatchOnItems = this.props.selectedMatchOnItems;
      this.filtersElementRef.current.selectedContentTypeItems = this.props.selectedContentTypeItems;
      this.filtersElementRef.current.matchOnItems = this.props.matchOnItems;
      this.filtersElementRef.current.contentTypeItems = this.props.contentTypeItems;
    }
  }

  public render(props: Props) {
    return html`
      <!-- Keep this div to maintain order during re-renders -->
      <!-- as best I can tell this is related to this issue regarding fragments https://github.com/preactjs/preact/issues/3737 -->
      <div class="autocomplete-filters-container">
        <${AUTOCOMPLETE_FILTERS_SELECTOR} ref=${this.filtersElementRef} key=${this.filtersKey} />
      </div>
    `;
  }
}
